import { buildModelManager } from "../builder.js";
const DefaultPublicScenarioAccessSelection = {
  __typename: true,
  id: true,
  accessType: true,
  cohortId: true,
  createdAt: true,
  grantedAt: true,
  grantedById: true,
  isActive: true,
  notes: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "publicScenarioAccess";
const pluralModelApiIdentifier = "publicScenarioAccesses";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPublicScenarioAccessSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultPublicScenarioAccessSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPublicScenarioAccessSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPublicScenarioAccessSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultPublicScenarioAccessSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPublicScenarioAccessSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultPublicScenarioAccessSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createPublicScenarioAccess",
    operationReturnType: "CreatePublicScenarioAccess",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      publicScenarioAccess: { required: false, type: "CreatePublicScenarioAccessInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPublicScenarioAccessSelection
  },
  {
    type: "action",
    operationName: "bulkCreatePublicScenarioAccesses",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreatePublicScenarioAccessesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPublicScenarioAccessSelection
  },
  {
    type: "action",
    operationName: "updatePublicScenarioAccess",
    operationReturnType: "UpdatePublicScenarioAccess",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      publicScenarioAccess: { required: false, type: "UpdatePublicScenarioAccessInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPublicScenarioAccessSelection
  },
  {
    type: "action",
    operationName: "bulkUpdatePublicScenarioAccesses",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdatePublicScenarioAccessesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultPublicScenarioAccessSelection
  },
  {
    type: "action",
    operationName: "deletePublicScenarioAccess",
    operationReturnType: "DeletePublicScenarioAccess",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeletePublicScenarioAccesses",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertPublicScenarioAccess",
    operationReturnType: "UpsertPublicScenarioAccess",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      publicScenarioAccess: { required: false, type: "UpsertPublicScenarioAccessInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreatePublicScenarioAccessResult": { hasReturnType: false },
      "... on UpdatePublicScenarioAccessResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultPublicScenarioAccessSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertPublicScenarioAccesses",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertPublicScenarioAccessesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultPublicScenarioAccessSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "publicScenarioAccessGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const PublicScenarioAccessManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultPublicScenarioAccessSelection,
  operations
);
export {
  DefaultPublicScenarioAccessSelection,
  PublicScenarioAccessManager
};
//# sourceMappingURL=PublicScenarioAccess.js.map
